export const getDomain = () => {
  const dArray = document.location.host.split('.');
  const move = dArray.includes('dev') ? -2 : -3;
  const domain =
    dArray.length > 2
      ? document.location.host.split('.').splice(move).join('.')
      : document.location.hostname;

  return domain;
};

export const getPageRoute = () => window.location.hash ? window.location.hash.replace('#', '') : "";
